import helpers from "../../js/helpers";
import shopify from "../../js/shopify";

export function getMobileBreakpoint(){
    return '1024px';
}

const ns = 'arctheme'
window.arcthemeNamespace = ns
window[ns] = (window[ns] || {})
window[ns].helpers = helpers

for (const [key, value] of Object.entries(helpers)) {
    window[ns].helpers[key] = value
}

// ----- Global API for external templates (e.g. Nosto) -----
if (!window[ns].fetchProductSwatches) {
  window[ns].fetchProductSwatches = async (tags) => {
    let normalizedTags;

    if (tags == null) {
      normalizedTags = [];
    } else if (Array.isArray(tags)) {
      normalizedTags = tags.map((tag) => String(tag));
    } else if (typeof tags === "string") {
      normalizedTags = [tags];
    } else {
      normalizedTags = [String(tags)];
    }

    try {
      return await shopify.getRelatedProductsByTagList(normalizedTags);
    } catch (error) {
      console.error('arctheme.fetchProductSwatches failed for tags:', tags, error);
      return [];
    }
  };
}